const isMultipleVariations = target => {
  if (typeof target !== 'string') {
    return false;
  }
  return target.includes('buy-multiple-variations');
};
export { isMultipleVariations };
